import { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './components/Home';
import { FaWhatsapp } from 'react-icons/fa';
import ScrollToTop from './components/ScrollToTop';

const PlanDetails = lazy(() => import('./components/PlanDetails'));
const QuienesSomosMejorado = lazy(() => import('./components/QuienesSomos.js'));
const Contacto = lazy(() => import('./components/Contacto.js'));



function App() {
  return (
    <Router>
            <ScrollToTop />

      <a
        href="https://wa.me/+56983221037" // Reemplaza con el número de WhatsApp
        className="whatsapp-button"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Escríbenos por WhatsApp"
      >
        <FaWhatsapp size={50} />
      </a>
      
      <div className="App flex flex-col min-h-screen" >
        <Header />
        <Suspense fallback={null}>
          <Routes>
          {/* Ruta principal que muestra los componentes principales */}
          <Route
            path="/"
            element={
              <>
                <Home />
              </>
            }
          />

          {/* Ruta dinámica para los detalles de cada plan */}
          <Route path="/PlanesDeServicio/:planId" element={<PlanDetails />} />
            
            {/* Ruta para la página Quienes Somos */}
          <Route path="/QuienesSomos" element={<QuienesSomosMejorado />} />
              
              {/* Ruta para la página de Contacto con componente reseñá */}
              <Route path="/Contacto" element={<div><Contacto /></div>} />

          
          
          </Routes>
        </Suspense>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
